import styled from "styled-components";
import Variables from "../styleVariables";

const COLORS = {
  red: {
    color: Variables.colors.red_600,
    backgroundColor: Variables.colors.red_100
  },
  blue: {
    color: Variables.colors.tertiary_700,
    backgroundColor: Variables.colors.tertiary_50
  }
};
export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  & > i {
    width: ${props => (props.size ? props.size + "px" : "40px")};
    height: ${props => (props.size ? props.size + "px" : "40px")};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 ${props => (props.mr ? props.mr + "px" : 0)} 0
      ${props => (props.ml ? props.ml + "px" : 0)};
    cursor: pointer;
    &:before {
      color: ${props =>
          props.color && props.normalModeIsColored
              ? COLORS[props.color].color
              : Variables.colors.complementary_700};
      margin-left: 0;
      font-size: ${props => (props.fontSize ? props.fontSize + "px" : "24px")};
    }
    &:hover {
      background-color: ${props =>
        props.color
          ? COLORS[props.color].backgroundColor
          : Variables.colors.complementary_300};
      &:before {
        color: ${props =>
          props.color
            ? COLORS[props.color].color
            : Variables.colors.complementary_700} !important;
      }
    }
  }
`;
